import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC } from 'react';
import Slider, { Settings } from 'react-slick';
import style from './SliderComponent.module.css';
import { clsx } from 'clsx';

export const SliderComponent: FC<Settings> = ({
  infinite = false,
  dots = true,
  arrows = false,
  className = '',
  children,
  dotsClass = '',
  ...props
}) => {
  return (
    <div className={clsx(style.slider, 'w-full')}>
      <Slider
        {...props}
        className={`${className} ${style.slickSlider}`}
        arrows={arrows}
        dots={dots}
        infinite={infinite}
        dotsClass={`slick-dots ${style.slickSliderDots} ${dotsClass}`}
      >
        {children}
      </Slider>
    </div>
  );
};
